/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTIcon } from '../../../helpers'

type Props = {
  className: string
}

const TablesWidget10: React.FC<Props> = ({ className }) => {
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Loan Statistics</span>
          {/* <span className='text-muted mt-1 fw-semibold fs-7'>Over 500 members</span> */}
        </h3>
        <div
          className='card-toolbar'
          data-bs-toggle='tooltip'
          data-bs-placement='top'
          data-bs-trigger='hover'
          title='Click to add a user'
        >
          <a
            href='/management/loans/applications'
            className='btn btn-sm btn-light-primary'
          // data-bs-toggle='modal'
          // data-bs-target='#kt_modal_invite_friends'
          >
            <KTIcon iconName='plus' className='fs-3' />
            Add New Member
          </a>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-9-check'
                    />
                  </div>
                </th>
                <th className='min-w-150px'>Name</th>
                <th className='min-w-140px'>Group</th>
                <th className='min-w-120px'>Date</th>
                <th className='min-w-120px'>Phone</th>
                <th className='min-w-120px'>Loan Amount</th>
                <th className='min-w-120px'>Due Amount</th>
                <th className='min-w-100px text-end'>Actions</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              <tr>
                <td>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                  </div>
                </td>
                <td>
                  <div className='d-flex align-items-center'>
                    {/* <div className='symbol symbol-45px me-5'>
                      <img src={toAbsoluteUrl('/media/avatars/300-14.jpg')} alt='' />
                    </div> */}
                    <div className='d-flex justify-content-start flex-column'>
                      <a href='#' className='text-dark fs-6'>
                        Ana Simmons
                      </a>
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Male
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    One Voice
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Chairperson
                  </span>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    {/* Ugx 50,000 */}
                    07 Nov 2022
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>MTN</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    0759853128
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 50,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Community Loan
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 60,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <div className='d-flex justify-content-end flex-shrink-0'>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='switch' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='pencil' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                    >
                      <KTIcon iconName='trash' className='fs-3' />
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                  </div>
                </td>
                <td>
                  <div className='d-flex align-items-center'>
                    {/* <div className='symbol symbol-45px me-5'>
                      <img src={toAbsoluteUrl('/media/avatars/300-14.jpg')} alt='' />
                    </div> */}
                    <div className='d-flex justify-content-start flex-column'>
                      <a href='#' className='text-dark fs-6'>
                        Ana Simmons
                      </a>
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Male
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    One Voice
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Chairperson
                  </span>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    {/* Ugx 50,000 */}
                    07 Nov 2022
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>MTN</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    0759853128
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 50,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Community Loan
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 60,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <div className='d-flex justify-content-end flex-shrink-0'>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='switch' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='pencil' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                    >
                      <KTIcon iconName='trash' className='fs-3' />
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                  </div>
                </td>
                <td>
                  <div className='d-flex align-items-center'>
                    {/* <div className='symbol symbol-45px me-5'>
                      <img src={toAbsoluteUrl('/media/avatars/300-14.jpg')} alt='' />
                    </div> */}
                    <div className='d-flex justify-content-start flex-column'>
                      <a href='#' className='text-dark fs-6'>
                        Ana Simmons
                      </a>
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Male
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    One Voice
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Chairperson
                  </span>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    {/* Ugx 50,000 */}
                    07 Nov 2022
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>MTN</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    0759853128
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 50,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Community Loan
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 60,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <div className='d-flex justify-content-end flex-shrink-0'>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='switch' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='pencil' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                    >
                      <KTIcon iconName='trash' className='fs-3' />
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                  </div>
                </td>
                <td>
                  <div className='d-flex align-items-center'>
                    {/* <div className='symbol symbol-45px me-5'>
                      <img src={toAbsoluteUrl('/media/avatars/300-14.jpg')} alt='' />
                    </div> */}
                    <div className='d-flex justify-content-start flex-column'>
                      <a href='#' className='text-dark fs-6'>
                        Ana Simmons
                      </a>
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Male
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    One Voice
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Chairperson
                  </span>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    {/* Ugx 50,000 */}
                    07 Nov 2022
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>MTN</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    0759853128
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 50,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Community Loan
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 60,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <div className='d-flex justify-content-end flex-shrink-0'>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='switch' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='pencil' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                    >
                      <KTIcon iconName='trash' className='fs-3' />
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                  </div>
                </td>
                <td>
                  <div className='d-flex align-items-center'>
                    {/* <div className='symbol symbol-45px me-5'>
                      <img src={toAbsoluteUrl('/media/avatars/300-14.jpg')} alt='' />
                    </div> */}
                    <div className='d-flex justify-content-start flex-column'>
                      <a href='#' className='text-dark fs-6'>
                        Ana Simmons
                      </a>
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Male
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    One Voice
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Chairperson
                  </span>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    {/* Ugx 50,000 */}
                    07 Nov 2022
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>MTN</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    0759853128
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 50,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Community Loan
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 60,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <div className='d-flex justify-content-end flex-shrink-0'>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='switch' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='pencil' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                    >
                      <KTIcon iconName='trash' className='fs-3' />
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                  </div>
                </td>
                <td>
                  <div className='d-flex align-items-center'>
                    {/* <div className='symbol symbol-45px me-5'>
                      <img src={toAbsoluteUrl('/media/avatars/300-14.jpg')} alt='' />
                    </div> */}
                    <div className='d-flex justify-content-start flex-column'>
                      <a href='#' className='text-dark fs-6'>
                        Ana Simmons
                      </a>
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Male
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    One Voice
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Chairperson
                  </span>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    {/* Ugx 50,000 */}
                    07 Nov 2022
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>MTN</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    0759853128
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 50,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Community Loan
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 60,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <div className='d-flex justify-content-end flex-shrink-0'>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='switch' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='pencil' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                    >
                      <KTIcon iconName='trash' className='fs-3' />
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                  </div>
                </td>
                <td>
                  <div className='d-flex align-items-center'>
                    {/* <div className='symbol symbol-45px me-5'>
                      <img src={toAbsoluteUrl('/media/avatars/300-14.jpg')} alt='' />
                    </div> */}
                    <div className='d-flex justify-content-start flex-column'>
                      <a href='#' className='text-dark fs-6'>
                        Ana Simmons
                      </a>
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Male
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    One Voice
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Chairperson
                  </span>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                    {/* Ugx 50,000 */}
                    07 Nov 2022
                  </a>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>MTN</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    0759853128
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 50,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Community Loan
                  </span>
                </td>
                <td>
                  <span className='text-dark fw-bold d-block fs-6'>Ugx 60,000</span>
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    14 Nov 2022
                  </span>
                </td>
                <td>
                  <div className='d-flex justify-content-end flex-shrink-0'>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='switch' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                      <KTIcon iconName='pencil' className='fs-3' />
                    </a>
                    <a
                      href='#'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                    >
                      <KTIcon iconName='trash' className='fs-3' />
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export { TablesWidget10 }
